import React, { CSSProperties } from 'react'
import classNames from 'classnames'

interface IProps {
  onClick?(): void
  className?: string
  style?: CSSProperties
}

const CardWrapper: React.FC<IProps> = ({
  children,
  onClick,
  style,
  className,
}) => {
  return (
    <React.Fragment>
      <section
        onClick={onClick}
        className={classNames(
          'community-card tw-text-common-black tw-text-16',
          className
        )}
        style={style}
      >
        {children}
      </section>
      <style jsx global>
        {`
          .community-card > div:first-child,
          .community-card > a:first-child > div {
            margin-top: 0;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default CardWrapper
